module.exports = __webpack_public_path__ + "media/images/index/area/faeture_chubu-17710d89fbd24b7fcc316f8663f9ad04.png";